import { render, staticRenderFns } from "./dashboard-views-utilities-area.vue?vue&type=template&id=39a0b973&scoped=true&"
import script from "./dashboard-views-utilities-area.ts?vue&type=script&lang=ts&"
export * from "./dashboard-views-utilities-area.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-views-utilities-area.scss?vue&type=style&index=0&id=39a0b973&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0b973",
  null
  
)

export default component.exports